// This file was automatically generated and should not be edited.

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends {[key: string]: unknown}> = {[K in keyof T]: T[K]};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {[SubKey in K]?: Maybe<T[SubKey]>};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {[SubKey in K]: Maybe<T[SubKey]>};
export type MakeEmpty<T extends {[key: string]: unknown}, K extends keyof T> = {[_ in K]?: never};
export type Incremental<T> =
  | T
  | {[P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: {input: string; output: string};
  String: {input: string; output: string};
  Boolean: {input: boolean; output: boolean};
  Int: {input: number; output: number};
  Float: {input: number; output: number};
  File: {input: unknown; output: unknown};
  ISO8601DateTime: {input: string; output: string};
  JSON: {input: unknown; output: unknown};
  PreciseDateTime: {input: unknown; output: unknown};
};

/** The minimum version of the ezManage Driver mobile app allowed for Android devices. */
export type AndroidConfig = {
  __typename?: 'AndroidConfig';
  build: Scalars['Int']['output'];
  transitionState: DriverAppTransitionState | `${DriverAppTransitionState}`;
  transitionUrl: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** Represents the ezManage Driver mobile app configuration. */
export type AppConfig = {
  __typename?: 'AppConfig';
  android: AndroidConfig;
  ios: IosConfig;
};

/** Autogenerated input type of CreateDeliveryEvent */
export type CreateDeliveryEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the driver assignment the event will be associated with */
  driverAssignmentId: Scalars['ID']['input'];
  eventType: DmDeliveryEventTypes | `${DmDeliveryEventTypes}`;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
};

/** Autogenerated return type of CreateDeliveryEvent. */
export type CreateDeliveryEventPayload = {
  __typename?: 'CreateDeliveryEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  driverAssignment?: Maybe<DmDriverAssignment>;
  /** @deprecated Replaced by field: userErrors. */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** The list of errors that happened from executing the mutation. */
  userErrors: Array<CreateDeliveryEventUserError>;
};

/** Autogenerated list of UserErrors for CreateDeliveryEvent */
export type CreateDeliveryEventUserError = ValidationError;

/** Provides a start and end time for a delivery window */
export type DeliveryArrivalWindow = {
  __typename?: 'DeliveryArrivalWindow';
  /** The latest date and time in UTC, ISO 8601 format, within the arrival window. */
  endAt: Scalars['ISO8601DateTime']['output'];
  /** The earliest date and time in UTC, ISO 8601 format, within the arrival window. */
  startAt: Scalars['ISO8601DateTime']['output'];
};

/** Details for the driver on whether they can assign themselves to the delivery. */
export type DeliveryMetadata = {
  __typename?: 'DeliveryMetadata';
  /**
   * Whether or not this delivery is assignable to drivers
   * @deprecated This is being removed in favor of `self_assignable`
   */
  assignable: Scalars['Boolean']['output'];
  /** Whether or not this delivery is assignable to drivers */
  selfAssignable: Scalars['Boolean']['output'];
  /** Reason why delivery is not considered assignable */
  unassignableReason?: Maybe<SelfAssignErrorTypes | `${SelfAssignErrorTypes}`>;
};

/** Allowed values for delivery setup */
export enum DeliverySetup {
  /** The customer declined delivery setup */
  None = 'NONE',
  /** The customer was not prompted for a delivery setup */
  NoResponse = 'NO_RESPONSE',
  /** The customer requested delivery setup */
  Required = 'REQUIRED',
}

/** Autogenerated input type of DestroyDriverSession */
export type DestroyDriverSessionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DestroyDriverSession. */
export type DestroyDriverSessionPayload = {
  __typename?: 'DestroyDriverSessionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The list of errors that happened from executing the mutation. */
  userErrors: Array<DestroyDriverSessionUserError>;
};

/** Autogenerated list of UserErrors for DestroyDriverSession */
export type DestroyDriverSessionUserError = ValidationError;

/** Delivery address object */
export type DmAddress = {
  __typename?: 'DmAddress';
  /** City of the address */
  city?: Maybe<Scalars['String']['output']>;
  /** UUID of the address */
  id: Scalars['ID']['output'];
  /** Delivery instructions for this address */
  instructions?: Maybe<Scalars['String']['output']>;
  /** Short name for the address ie. ezCater Office */
  locationName?: Maybe<Scalars['String']['output']>;
  /** Contact phone number for address type */
  phone?: Maybe<Scalars['String']['output']>;
  /** Two-letter state abbreviation */
  state?: Maybe<Scalars['String']['output']>;
  /** Street1 of the address */
  street1?: Maybe<Scalars['String']['output']>;
  /** Optional street2 of the address */
  street2?: Maybe<Scalars['String']['output']>;
  /** Optional extended address */
  street3?: Maybe<Scalars['String']['output']>;
  /** Time zone used for the address */
  timeZoneIdentifier?: Maybe<Scalars['String']['output']>;
  /** Postal code of the address */
  zip?: Maybe<Scalars['String']['output']>;
};

/** Details of the ezCater delivery. */
export type DmDelivery = {
  __typename?: 'DmDelivery';
  /** Whether or not this delivery is assignable to drivers */
  assignable: Scalars['Boolean']['output'];
  cancelled: Scalars['Boolean']['output'];
  deliveryEvents: Array<DmDeliveryEvent>;
  /** The delivery setup option selected by the customer for the delivery. */
  deliverySetup: DeliverySetup | `${DeliverySetup}`;
  /** Approximated distance between pickup and dropoff. */
  distanceInMiles?: Maybe<Scalars['Float']['output']>;
  driverAskFor?: Maybe<Scalars['String']['output']>;
  dropoffAddress: DmAddress;
  dropoffWindow?: Maybe<DeliveryArrivalWindow>;
  /** Approximated travel time between pickup and dropoff. */
  durationInMinutes?: Maybe<Scalars['Int']['output']>;
  eventAt: Scalars['ISO8601DateTime']['output'];
  /** The event time adjusted with the default buffer if applicable. This does not include delivery partner padding for ezdispatch deliveries. */
  eventAtWithPadding: Scalars['ISO8601DateTime']['output'];
  /** The order number (reference_id) formatted for standard ezCater display - #ABC-123 */
  formattedOrderNumber: Scalars['String']['output'];
  /** Whether or not in progress information exists for this delivery. */
  hasTrackingInformation: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  order: DmOrder;
  /** The UUID of the ezCater order. */
  orderId: Scalars['String']['output'];
  /** The unformatted ezCater order number. */
  orderNumber: Scalars['String']['output'];
  /** The UUID of the ezCater order. */
  orderUuid: Scalars['String']['output'];
  pickupAddress: DmAddress;
  /** The time for pickup via the delivery partner. */
  pickupAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The priority of the delivery. */
  priority: DmDeliveryPriority | `${DmDeliveryPriority}`;
  status?: Maybe<DmDeliveryStatus | `${DmDeliveryStatus}`>;
  /** Returns the most recent tracking delivery event */
  statusEvent?: Maybe<DmDeliveryEvent>;
  /** Fields that are missing information or contain validation errors. */
  validationErrors?: Maybe<Scalars['JSON']['output']>;
};

/** Details of the ezCater delivery. */
export type DmDeliveryDeliveryEventsArgs = {
  eventTypes?: InputMaybe<Array<DmDeliveryEventTypes>>;
  sortDirection?: InputMaybe<SortDirection>;
};

/** Events about the delivery created during the delivery lifecycle. */
export type DmDeliveryEvent = {
  __typename?: 'DmDeliveryEvent';
  /** ID of the associated Delivery. */
  deliveryId: Scalars['ID']['output'];
  eventType: DmDeliveryEventTypes | `${DmDeliveryEventTypes}`;
  id: Scalars['ID']['output'];
  /** The time the event occurred with microsecond precision. */
  occurredAt: Scalars['PreciseDateTime']['output'];
  /** The event creation source. */
  source: DmDeliveryEventSource | `${DmDeliveryEventSource}`;
  time: Scalars['ISO8601DateTime']['output'];
};

/** The delivery event creation source, whether directly or indirectly. */
export enum DmDeliveryEventSource {
  /** This is the default event source and any events that don't match other sources will be set to this. */
  DeliveryManagement = 'DELIVERY_MANAGEMENT',
  /** The event is directly from or a byproduct of a delivery partner. */
  DeliveryPartner = 'DELIVERY_PARTNER',
  /** The event is directly from or a byproduct of an ezDispatch process. */
  Ezdispatch = 'EZDISPATCH',
  /** The event was created from driver geolocation. */
  Geolocation = 'GEOLOCATION',
  /** The event was created from a 1st Party Delivery API integration. */
  PublicDeliveryApi = 'PUBLIC_DELIVERY_API',
}

/** The event type for any given event */
export enum DmDeliveryEventTypes {
  /** The ezDispatch request has been accepted - either programatically or by a third party delivery partner */
  Accepted = 'accepted',
  /** ezDispatch has cancelled the assignment to a third party delivery partner */
  AssignmentCancelled = 'assignment_cancelled',
  /** ezDispatch has assigned the delivery to a third party delivery partner */
  AssignmentCreated = 'assignment_created',
  /** The delivery has been cancelled completely */
  Cancelled = 'cancelled',
  /** A delivery record has been created in either delivery management or ezDispatch */
  Created = 'created',
  /** A driver has arrived at the dropoff location */
  DriverArrivedAtDropoff = 'driver_arrived_at_dropoff',
  /** A driver has arrived to pickup the food */
  DriverArrivedAtPickup = 'driver_arrived_at_pickup',
  /** A driver has been assigned - either by a catering partner or a third party delivery partner */
  DriverAssigned = 'driver_assigned',
  /** A driver has dropped of the food */
  DriverDroppedOff = 'driver_dropped_off',
  /** A driver is on the way to the customer */
  DriverEnRouteToDropoff = 'driver_en_route_to_dropoff',
  /** A driver is on the way to pickup the food */
  DriverEnRouteToPickup = 'driver_en_route_to_pickup',
  /** A driver has picked the food */
  DriverPickedUp = 'driver_picked_up',
  /** A driver has given feedback after completing a delivery */
  DriverProvidedFeedback = 'driver_provided_feedback',
  /**
   * A driver has reported that they are behind schedule
   * @deprecated This is being deprecated without any alternative. No delivery events have been created with this event type since 2022-02-09.
   */
  DriverReportedLateness = 'driver_reported_lateness',
  /** A gps location has been reported for a driver */
  DriverReportedLocation = 'driver_reported_location',
  /** A driver has been unassigned - either by a catering partner or third party delivery partner */
  DriverUnassigned = 'driver_unassigned',
  /** The delivery was not completed at least two hours after the scheduled event */
  Expired = 'expired',
  /** Some sort of issue has been reported with the delivery. */
  Issue = 'issue',
  /** Delivery related information has changed */
  Modified = 'modified',
  /** The delivery has been rejected by ezDispatch or an assignment has been rejected by a third party delivery partner */
  Rejected = 'rejected',
  /** ezDispatch request was deleted by the caterer. */
  RequestDeletedByCaterer = 'request_deleted_by_caterer',
  /** ezDispatch request was deleted by the customer. */
  RequestDeletedByCustomer = 'request_deleted_by_customer',
  /** ezDispatch request was deleted by the delivery partner. */
  RequestDeletedByDeliveryPartner = 'request_deleted_by_delivery_partner',
}

/** The priority level of an ezDispatch delivery. */
export enum DmDeliveryPriority {
  /** A delivery that needs higher priority. */
  High = 'HIGH',
  /** A normal delivery priority. This is the default. */
  Normal = 'NORMAL',
}

/** Current state - unassigned, assigned, in_progress, completed or expired - based on associated delivery events */
export enum DmDeliveryStatus {
  Assigned = 'assigned',
  Completed = 'completed',
  Expired = 'expired',
  InProgress = 'in_progress',
  Unassigned = 'unassigned',
}

/** Represents a delivery driver. */
export type DmDriver = {
  __typename?: 'DmDriver';
  /** A globally-unique identifier. */
  id: Scalars['ID']['output'];
};

/** Represents the association between a delivery and driver. */
export type DmDriverAssignment = {
  __typename?: 'DmDriverAssignment';
  delivery: DmDelivery;
  /** Latest delivery event type */
  deliveryStatus: DmDeliveryEventTypes | `${DmDeliveryEventTypes}`;
  driver: DmDriver;
  driverImages: Array<DriverImage>;
  feedback?: Maybe<DmDriverFeedback>;
  id: Scalars['ID']['output'];
  maskedPhoneNumber?: Maybe<Scalars['String']['output']>;
};

/** Represents post delivery feedback provided from the delivery driver. */
export type DmDriverFeedback = {
  __typename?: 'DmDriverFeedback';
  dropoffLocation?: Maybe<Scalars['String']['output']>;
  liked: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
};

/** The vendor hosting the image. */
export enum DmDriverImageVendor {
  Filestack = 'FILESTACK',
}

/** Driver current SMS opt in status - no opt in decision, opted in, opted out */
export enum DmDriverOptInStatus {
  NoOptInDecision = 'NO_OPT_IN_DECISION',
  OptedIn = 'OPTED_IN',
  OptedOut = 'OPTED_OUT',
}

/** Represents the delivery specific ezCater order information. */
export type DmOrder = {
  __typename?: 'DmOrder';
  ezcaterStoreId?: Maybe<Scalars['ID']['output']>;
  /** The number of items in the order. */
  itemCount: Scalars['Int']['output'];
  /** List of items with name/count on the order */
  orderItems: Array<DmOrderItem>;
  /** The ezCater order number. */
  orderNumber: Scalars['String']['output'];
  /** The subtotal value of the order in dollars. */
  subtotal: Scalars['Float']['output'];
  /** The subtotal value of the order in cents. */
  subtotalCents: Scalars['Int']['output'];
  /** The tip value in dollars. */
  tip: Scalars['Float']['output'];
  /** The tip value in cents. */
  tipCents: Scalars['Int']['output'];
};

/** Individual selections and quantities from the menu a customer purchased. */
export type DmOrderItem = {
  __typename?: 'DmOrderItem';
  /** Name for this item in the cart. */
  name: Scalars['String']['output'];
  /** Quantity for this item in the cart. */
  quantity: Scalars['Int']['output'];
};

/** Represents the identity of a Driver app user. */
export type Driver = {
  __typename?: 'Driver';
  /** The driver's first name. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** A globally-unique identifier. */
  id: Scalars['ID']['output'];
  /** The driver's last name. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The driver's mobile phone number. */
  phone: Scalars['String']['output'];
  /** The status of whether the driver has consented to receiving SMS from ezCater. */
  smsOptInStatus?: Maybe<DmDriverOptInStatus | `${DmDriverOptInStatus}`>;
};

/** Autogenerated input type of DriverAcceptSmsTerms */
export type DriverAcceptSmsTermsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DriverAcceptSmsTerms. */
export type DriverAcceptSmsTermsPayload = {
  __typename?: 'DriverAcceptSmsTermsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated This is being deprecated without any alternative. */
  driver?: Maybe<DmDriver>;
  /** @deprecated Replaced by field: userErrors. */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** The list of errors that happened from executing the mutation. */
  userErrors: Array<DriverAcceptSmsTermsUserError>;
};

/** Autogenerated list of UserErrors for DriverAcceptSmsTerms */
export type DriverAcceptSmsTermsUserError = ValidationError;

/** Autogenerated input type of DriverAccountSelfDelete */
export type DriverAccountSelfDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DriverAccountSelfDelete. */
export type DriverAccountSelfDeletePayload = {
  __typename?: 'DriverAccountSelfDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated This is being deprecated without any alternative. */
  driver?: Maybe<DmDriver>;
  /** @deprecated Replaced by field: userErrors. */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** The list of errors that happened from executing the mutation. */
  userErrors: Array<DriverAccountSelfDeleteUserError>;
};

/** Autogenerated list of UserErrors for DriverAccountSelfDelete */
export type DriverAccountSelfDeleteUserError = ValidationError;

/** Represents the current transition experience for the Driver Mobile App */
export enum DriverAppTransitionState {
  Enforce = 'ENFORCE',
  None = 'NONE',
  Suggest = 'SUGGEST',
}

/** Autogenerated input type of DriverFeedback */
export type DriverFeedbackInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the driver assignment */
  driverAssignmentId: Scalars['ID']['input'];
  dropoffLocation?: InputMaybe<Scalars['String']['input']>;
  liked?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DriverFeedback. */
export type DriverFeedbackPayload = {
  __typename?: 'DriverFeedbackPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by field: userErrors. */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  feedback?: Maybe<DmDriverFeedback>;
  /** The list of errors that happened from executing the mutation. */
  userErrors: Array<DriverFeedbackUserError>;
};

/** Autogenerated list of UserErrors for DriverFeedback */
export type DriverFeedbackUserError = ValidationError;

/** Represents an image added by a delivery driver for proof of delivery. */
export type DriverImage = {
  __typename?: 'DriverImage';
  /** @deprecated Replaced by field: referenceId */
  filestackHandle?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by field: url */
  filestackUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  referenceId?: Maybe<Scalars['ID']['output']>;
  url: Scalars['String']['output'];
  /** The vendor hosting the image. */
  vendor?: Maybe<DmDriverImageVendor | `${DmDriverImageVendor}`>;
};

/** Represents an error that happens during execution of a mutation. */
export type Error = {
  __typename?: 'Error';
  code: Scalars['Int']['output'];
  message: Scalars['String']['output'];
};

/** The minimum version of the ezManage Driver mobile app allowed for iOS devices. */
export type IosConfig = {
  __typename?: 'IosConfig';
  build: Scalars['String']['output'];
  transitionState: DriverAppTransitionState | `${DriverAppTransitionState}`;
  transitionUrl: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** Autogenerated input type of MagicLinkDriverSessionCreate */
export type MagicLinkDriverSessionCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

/** Autogenerated return type of MagicLinkDriverSessionCreate. */
export type MagicLinkDriverSessionCreatePayload = {
  __typename?: 'MagicLinkDriverSessionCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns whether or not the request was successful */
  success: Scalars['Boolean']['output'];
  /** The list of errors that happened from executing the mutation. */
  userErrors: Array<MagicLinkDriverSessionCreateUserError>;
};

/** Autogenerated list of UserErrors for MagicLinkDriverSessionCreate */
export type MagicLinkDriverSessionCreateUserError = ValidationError;

/** Autogenerated input type of MagicLinkRequest */
export type MagicLinkRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deliveryId?: InputMaybe<Scalars['ID']['input']>;
  driverAssignmentId?: InputMaybe<Scalars['ID']['input']>;
  phone: Scalars['String']['input'];
  /** The source of where the driver assignment occured */
  source?: InputMaybe<SelfAssignSource | `${SelfAssignSource}`>;
};

/** Autogenerated return type of MagicLinkRequest. */
export type MagicLinkRequestPayload = {
  __typename?: 'MagicLinkRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by field: userErrors. */
  errors?: Maybe<Array<Error>>;
  /** Returns whether or not the request was successful */
  success: Scalars['Boolean']['output'];
  /** The list of errors that happened from executing the mutation. */
  userErrors: Array<MagicLinkRequestUserError>;
};

/** Autogenerated list of UserErrors for MagicLinkRequest */
export type MagicLinkRequestUserError = ValidationError;

/** Autogenerated input type of MaskedPhoneNumber */
export type MaskedPhoneNumberInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the driver assignment */
  driverAssignmentId: Scalars['ID']['input'];
};

/** Autogenerated return type of MaskedPhoneNumber. */
export type MaskedPhoneNumberPayload = {
  __typename?: 'MaskedPhoneNumberPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  driverAssignment?: Maybe<DmDriverAssignment>;
  /** @deprecated Replaced by field: userErrors. */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** The list of errors that happened from executing the mutation. */
  userErrors: Array<MaskedPhoneNumberUserError>;
};

/** Autogenerated list of UserErrors for MaskedPhoneNumber */
export type MaskedPhoneNumberUserError = ValidationError;

export type Mutation = {
  __typename?: 'Mutation';
  /** Update the delivery timeline with the latest driver progress by either adding a new event or reporting the current driver location. */
  createDeliveryEvent?: Maybe<CreateDeliveryEventPayload>;
  /** Destroys a Driver Session */
  destroyDriverSession?: Maybe<DestroyDriverSessionPayload>;
  /** Accepts the SMS compliance terms for the driver. */
  driverAcceptSmsTerms?: Maybe<DriverAcceptSmsTermsPayload>;
  /** Soft deletes the drivers account of PII */
  driverAccountSelfDelete?: Maybe<DriverAccountSelfDeletePayload>;
  /** Creates a new Driver Feedback */
  driverFeedback?: Maybe<DriverFeedbackPayload>;
  /** Creates a magic link session + sets auth cookie given a token */
  magicLinkDriverSessionCreate?: Maybe<MagicLinkDriverSessionCreatePayload>;
  /** Allows a driver to request a magic link for login */
  magicLinkRequest?: Maybe<MagicLinkRequestPayload>;
  /** Creates or returns a masked phone number for a driver assignment */
  maskedPhoneNumber?: Maybe<MaskedPhoneNumberPayload>;
  /** Removes all assignments for a delivery */
  removeAssignments?: Maybe<RemoveAssignmentsPayload>;
  /** Allows the driver to request invitation by phone number */
  requestAccountCreate?: Maybe<RequestAccountCreatePayload>;
  /** Allows Driver to assign a delivery to themselves */
  selfAssignDriver?: Maybe<SelfAssignDriverPayload>;
  /** Create a Driver Image using the filestack API */
  uploadAssignmentImage?: Maybe<UploadAssignmentImagePayload>;
};

export type MutationCreateDeliveryEventArgs = {
  input: CreateDeliveryEventInput;
};

export type MutationDestroyDriverSessionArgs = {
  input: DestroyDriverSessionInput;
};

export type MutationDriverAcceptSmsTermsArgs = {
  input: DriverAcceptSmsTermsInput;
};

export type MutationDriverAccountSelfDeleteArgs = {
  input: DriverAccountSelfDeleteInput;
};

export type MutationDriverFeedbackArgs = {
  input: DriverFeedbackInput;
};

export type MutationMagicLinkDriverSessionCreateArgs = {
  input: MagicLinkDriverSessionCreateInput;
};

export type MutationMagicLinkRequestArgs = {
  input: MagicLinkRequestInput;
};

export type MutationMaskedPhoneNumberArgs = {
  input: MaskedPhoneNumberInput;
};

export type MutationRemoveAssignmentsArgs = {
  input: RemoveAssignmentsInput;
};

export type MutationRequestAccountCreateArgs = {
  input: RequestAccountCreateInput;
};

export type MutationSelfAssignDriverArgs = {
  input: SelfAssignDriverInput;
};

export type MutationUploadAssignmentImageArgs = {
  input: UploadAssignmentImageInput;
};

export type Query = {
  __typename?: 'Query';
  _service: _Service;
  appConfig: AppConfig;
  deliveryMetadata: DeliveryMetadata;
  dmDriverAssignment: DmDriverAssignment;
  /** The current delivery management driver identity */
  dmMe?: Maybe<Driver>;
  driverAssignments: Array<DmDriverAssignment>;
  /** @deprecated This is retired in preparation for federated schema, use dmMe instead */
  me?: Maybe<Driver>;
};

export type QueryDeliveryMetadataArgs = {
  id: Scalars['ID']['input'];
};

export type QueryDmDriverAssignmentArgs = {
  id: Scalars['ID']['input'];
};

export type QueryDriverAssignmentsArgs = {
  eventAtRange?: InputMaybe<TimeRangeInput>;
};

/** Autogenerated input type of RemoveAssignments */
export type RemoveAssignmentsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the delivery to be unassigned */
  deliveryId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveAssignments. */
export type RemoveAssignmentsPayload = {
  __typename?: 'RemoveAssignmentsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deliveryId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by field: userErrors. */
  errors?: Maybe<Array<Error>>;
  /** The list of errors that happened from executing the mutation. */
  userErrors: Array<RemoveAssignmentsUserError>;
};

/** Autogenerated list of UserErrors for RemoveAssignments */
export type RemoveAssignmentsUserError = ValidationError;

/** Autogenerated input type of RequestAccountCreate */
export type RequestAccountCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deliveryId?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
};

/** Autogenerated return type of RequestAccountCreate. */
export type RequestAccountCreatePayload = {
  __typename?: 'RequestAccountCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by field: userErrors. */
  errors?: Maybe<Array<Error>>;
  phone?: Maybe<Scalars['String']['output']>;
  /** The list of errors that happened from executing the mutation. */
  userErrors: Array<RequestAccountCreateUserError>;
};

/** Autogenerated list of UserErrors for RequestAccountCreate */
export type RequestAccountCreateUserError = ValidationError;

/** Autogenerated input type of SelfAssignDriver */
export type SelfAssignDriverInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the delivery to be assigned to */
  deliveryId: Scalars['ID']['input'];
  /** Driver provided first name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Driver provided last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Origin of the request */
  source?: InputMaybe<SelfAssignSource | `${SelfAssignSource}`>;
};

/** Autogenerated return type of SelfAssignDriver. */
export type SelfAssignDriverPayload = {
  __typename?: 'SelfAssignDriverPayload';
  assignable?: Maybe<Scalars['Boolean']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deliveryId?: Maybe<Scalars['String']['output']>;
  driverAssignmentId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by field: userErrors. */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** The list of errors that happened from executing the mutation. */
  userErrors: Array<SelfAssignDriverUserError>;
};

/** Autogenerated list of UserErrors for SelfAssignDriver */
export type SelfAssignDriverUserError = ValidationError;

/** Reasons why a delivery may not be self assignabled */
export enum SelfAssignErrorTypes {
  /** Delivery is already assigned to another driver */
  Assigned = 'assigned',
  /** Delivery is now ezDispatch */
  Ezdispatch = 'ezdispatch',
  /** Delivery is now in a completed/expired/cancelled state */
  Finalized = 'finalized',
  /** Delivery is being handled by Relish */
  Relish = 'relish',
  /** Delivery is now takeout */
  Takeout = 'takeout',
}

/** Sources from where the driver initiated the self assign */
export enum SelfAssignSource {
  /** Via the flash message on Order Details */
  Alert = 'alert',
  /** Via the caterer accept flow */
  CatererAccept = 'caterer_accept',
  /** Via the food prep flow */
  FoodPrep = 'food_prep',
  /** Via the QR Code on the Order PDF */
  Qrcode = 'qrcode',
  /** Via an SMS with a link to sign up */
  Sms = 'sms',
}

/** Allowed values for query sorting */
export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

/** Range of timestamps */
export type TimeRangeInput = {
  ending: Scalars['ISO8601DateTime']['input'];
  starting: Scalars['ISO8601DateTime']['input'];
};

/** Autogenerated input type of UploadAssignmentImage */
export type UploadAssignmentImageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the driver assignment */
  driverAssignmentId: Scalars['ID']['input'];
  image: Scalars['File']['input'];
};

/** Autogenerated return type of UploadAssignmentImage. */
export type UploadAssignmentImagePayload = {
  __typename?: 'UploadAssignmentImagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  driverAssignment?: Maybe<DmDriverAssignment>;
  /** @deprecated Replaced by field: userErrors. */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** The list of errors that happened from executing the mutation. */
  userErrors: Array<UploadAssignmentImageUserError>;
};

/** Autogenerated list of UserErrors for UploadAssignmentImage */
export type UploadAssignmentImageUserError = ValidationError;

/** Errors encountered during processing */
export type UserError = {
  /** A description of the error */
  message: Scalars['String']['output'];
  /** A path to the input value that caused the error */
  path: Array<Scalars['String']['output']>;
};

/** Validation Error */
export type ValidationError = UserError & {
  __typename?: 'ValidationError';
  /** A description of the error */
  message: Scalars['String']['output'];
  /** A path to the input value that caused the error */
  path: Array<Scalars['String']['output']>;
};

/** The sdl representing the federated service capabilities. Includes federation directives, removes federation types, and includes rest of full schema after schema directives have been applied */
export type _Service = {
  __typename?: '_Service';
  sdl?: Maybe<Scalars['String']['output']>;
};

export type CreateDeliveryEventMutationVariables = Exact<{
  input: CreateDeliveryEventInput;
}>;

export type CreateDeliveryEventMutation = {
  createDeliveryEvent?: {
    __typename?: 'CreateDeliveryEventPayload';
    driverAssignment?: {
      __typename?: 'DmDriverAssignment';
      id: string;
      deliveryStatus: DmDeliveryEventTypes;
    } | null;
    userErrors: Array<{__typename?: 'ValidationError'; message: string}>;
  } | null;
};

export type DriverAccountSelfDeleteMutationVariables = Exact<{
  input: DriverAccountSelfDeleteInput;
}>;

export type DriverAccountSelfDeleteMutation = {
  driverAccountSelfDelete?: {
    __typename?: 'DriverAccountSelfDeletePayload';
    errors?: Array<string> | null;
  } | null;
};

export type DeliveryMetadataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeliveryMetadataQuery = {
  deliveryMetadata: {
    __typename?: 'DeliveryMetadata';
    assignable: boolean;
    unassignableReason?: SelfAssignErrorTypes | null;
  };
};

export type DestroyDriverSessionMutationVariables = Exact<{
  input: DestroyDriverSessionInput;
}>;

export type DestroyDriverSessionMutation = {
  destroyDriverSession?: {
    __typename?: 'DestroyDriverSessionPayload';
    clientMutationId?: string | null;
  } | null;
};

export type DriverAcceptSmsTermsMutationVariables = Exact<{
  input: DriverAcceptSmsTermsInput;
}>;

export type DriverAcceptSmsTermsMutation = {
  driverAcceptSmsTerms?: {
    __typename?: 'DriverAcceptSmsTermsPayload';
    errors?: Array<string> | null;
  } | null;
};

export type DriverAssignmentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DriverAssignmentQuery = {
  driverAssignment: {
    __typename?: 'DmDriverAssignment';
    id: string;
    deliveryStatus: DmDeliveryEventTypes;
    delivery: {
      __typename?: 'DmDelivery';
      id: string;
      orderNumber: string;
      eventAt: string;
      deliverySetup: DeliverySetup;
      distanceInMiles?: number | null;
      durationInMinutes?: number | null;
      driverAskFor?: string | null;
      pickupAddress: {
        __typename?: 'DmAddress';
        id: string;
        instructions?: string | null;
        locationName?: string | null;
        street1?: string | null;
        street2?: string | null;
        city?: string | null;
        state?: string | null;
        zip?: string | null;
      };
      dropoffAddress: {
        __typename?: 'DmAddress';
        id: string;
        locationName?: string | null;
        street1?: string | null;
        street2?: string | null;
        city?: string | null;
        state?: string | null;
        zip?: string | null;
        phone?: string | null;
        instructions?: string | null;
        timeZoneIdentifier?: string | null;
      };
      dropoffWindow?: {__typename?: 'DeliveryArrivalWindow'; endAt: string; startAt: string} | null;
      order: {
        __typename?: 'DmOrder';
        orderItems: Array<{__typename?: 'DmOrderItem'; name: string; quantity: number}>;
      };
    };
  };
};

export type DriverAssignmentsQueryVariables = Exact<{
  eventAtRange?: InputMaybe<TimeRangeInput>;
}>;

export type DriverAssignmentsQuery = {
  driverAssignments: Array<{
    __typename?: 'DmDriverAssignment';
    id: string;
    deliveryStatus: DmDeliveryEventTypes;
    delivery: {
      __typename?: 'DmDelivery';
      id: string;
      eventAt: string;
      orderNumber: string;
      pickupAddress: {__typename?: 'DmAddress'; id: string; timeZoneIdentifier?: string | null};
      dropoffAddress: {
        __typename?: 'DmAddress';
        id: string;
        locationName?: string | null;
        street1?: string | null;
        street2?: string | null;
        city?: string | null;
        state?: string | null;
        zip?: string | null;
      };
      dropoffWindow?: {__typename?: 'DeliveryArrivalWindow'; endAt: string; startAt: string} | null;
    };
  }>;
};

export type DriverFeedbackMutationVariables = Exact<{
  input: DriverFeedbackInput;
}>;

export type DriverFeedbackMutation = {
  driverFeedback?: {
    __typename?: 'DriverFeedbackPayload';
    userErrors: Array<{__typename?: 'ValidationError'; message: string}>;
  } | null;
};

export type MagicLinkDriverSessionCreateMutationVariables = Exact<{
  input: MagicLinkDriverSessionCreateInput;
}>;

export type MagicLinkDriverSessionCreateMutation = {
  magicLinkDriverSessionCreate?: {
    __typename?: 'MagicLinkDriverSessionCreatePayload';
    success: boolean;
  } | null;
};

export type MaskedPhoneNumberMutationVariables = Exact<{
  input: MaskedPhoneNumberInput;
}>;

export type MaskedPhoneNumberMutation = {
  maskedPhoneNumber?: {
    __typename?: 'MaskedPhoneNumberPayload';
    driverAssignment?: {
      __typename?: 'DmDriverAssignment';
      id: string;
      maskedPhoneNumber?: string | null;
    } | null;
    userErrors: Array<{__typename?: 'ValidationError'; message: string}>;
  } | null;
};

export type MeQueryVariables = Exact<{[key: string]: never}>;

export type MeQuery = {
  me?: {
    __typename?: 'Driver';
    id: string;
    firstName?: string | null;
    lastName?: string | null;
    phone: string;
    smsOptInStatus?: DmDriverOptInStatus | null;
  } | null;
};

export type RemoveAssignmentsMutationVariables = Exact<{
  input: RemoveAssignmentsInput;
}>;

export type RemoveAssignmentsMutation = {
  removeAssignments?: {
    __typename?: 'RemoveAssignmentsPayload';
    deliveryId?: string | null;
    userErrors: Array<{__typename?: 'ValidationError'; message: string}>;
  } | null;
};

export type RequestAccountCreateMutationVariables = Exact<{
  input: RequestAccountCreateInput;
}>;

export type RequestAccountCreateMutation = {
  requestAccountCreate?: {
    __typename?: 'RequestAccountCreatePayload';
    phone?: string | null;
    errors?: Array<{__typename?: 'Error'; message: string}> | null;
  } | null;
};

export type MagicLinkRequestMutationVariables = Exact<{
  input: MagicLinkRequestInput;
}>;

export type MagicLinkRequestMutation = {
  magicLinkRequest?: {
    __typename?: 'MagicLinkRequestPayload';
    success: boolean;
    errors?: Array<{__typename?: 'Error'; message: string}> | null;
  } | null;
};

export type SelfAssignDriverMutationVariables = Exact<{
  input: SelfAssignDriverInput;
}>;

export type SelfAssignDriverMutation = {
  selfAssignDriver?: {
    __typename?: 'SelfAssignDriverPayload';
    driverAssignmentId?: string | null;
    userErrors: Array<{__typename?: 'ValidationError'; message: string}>;
  } | null;
};
